<template>
  <div class="p-0  rounded " @click="selectedDay()" :class="modeItemClass">
    <reservation-day-mode v-if="reservationMode=='day'" :day="day"/>
    <reservation-hour-mode v-if="reservationMode=='hour'" :day="day"/>
  </div>
</template>

<script>
import {formatNumber, dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import ReservationDayMode from "./ReservationDayComponent/ReservationDayMode.vue";
import ReservationHourMode from "./ReservationDayComponent/ReservationHourMode.vue";

export default {
  name: "ReservationDay",
  components: {ReservationDayMode, ReservationHourMode},
  props: {
    day: {},
    selectedDays: {
      default: []
    },
    reservationMode: {
      default: 'day'
    }
  },
  computed: {
    isDayActive() {
      return this.selectedDays.includes(this.day)
    },
    hourModeItemClass() {
      return {'btn disabled': this.day.reserved, 'btn day-active': this.isDayActive}
    },
    dayModeItemClass() {
      return {'btn disabled': this.day.reserved, 'btn day-active': this.isDayActive}
    },
    modeItemClass() {
      return this.reservationMode === 'day' ? {...this.dayModeItemClass,'day-mode-day':true} : {...this.hourModeItemClass, 'hour-mode-day': true}
    }
  },
  methods: {
    formatNumber,
    dateConverter,
    selectedDay() {
      if (!this.day.reserved) {
        this.$emit('selectedDay', this.day)
      }
    },
  }
}
</script>


<style scoped>

.hour-mode-day {
  position: relative;
  width: calc(13.2857%);
  display: inline-block;
  margin: 1px;
  border: 1px solid rgb(234, 234, 234);
  font-size: 15px;
  vertical-align: baseline;
}

.day-mode-day {
  position: relative;
  width: calc(13.2857%);
  display: flex;
  margin: 1px;
  border: 1px solid rgb(234, 234, 234);
  justify-content: center;
  align-items: center;
  font-size: 13px;
  vertical-align: baseline;
}

.hour-mode-day :deep(.reservation-price-without-offer) {
  font-size: 13px;
}

.hour-mode-day :deep(.reservation-price) {
  font-size: 14px;
}


.day-active {
  border: 1px solid rgb(234, 234, 234);
  background: var(--primary);
}
</style>